<template>
  <div id="main-four" class="item">
    <div class="three-title">
      <span class="title">客户案例</span>
      <span class="text">公司以服务客户为宗旨 时刻将客户的利益放在第一位</span>
    </div>
    <div class="main-three-footer">
      <div class="main-three-item" v-for="item in dateList[num]" :key="item">
        <img :src=item alt="">
        <div class="footer-text">
          <div class="left">
            <span class="left-title">09.15</span>
            <span class="left-text">2022</span>
            <span class="left-line"></span>
          </div>
          <div class="right">
            <span class="right-title">广东省佛山市三水区蓝益电站0.87MWp</span>
            <span class="right-text">全量数据采集,顺利上送调度</span>
          </div>
        </div>
      </div>
      <div :class="[targetId==1?'three-left':'three-right','three-left-pos']" @click="jian">
        <i class="el-icon-arrow-left" type="primary"></i>
      </div>
      <div :class="[targetId==2?'three-left':'three-right','three-right-pos']"  @click="jia">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import frame1Page from "@/assets/image/frame1.png";
import frame2Page from "@/assets/image/frame2.png";
import frame3Page from "@/assets/image/frame3.png";
import frame4Page from "@/assets/image/frame4.png";
import frame5Page from "@/assets/image/frame5.png";
import frame6Page from "@/assets/image/frame6.png";
export default {
  name: "KhPage",
  data(){
    return{
      frame1Page,frame2Page,frame3Page,frame4Page,frame5Page,frame6Page,
      targetId:1,
      dateList:[
        [frame1Page,frame2Page,frame3Page],
        [frame4Page,frame5Page,frame6Page]
      ],
      num:0,
    }
  },
  methods:{
    jia(){
      this.targetId=2
     if(this.num==this.dateList.length-1){
       this.num=this.dateList.length-1
     }else {
       this.num++
     }
    },
    jian(){
      this.targetId=1
      if(this.num==0){
        this.num=0
      }else {
        this.num--
      }
    }
  }

}
</script>

<style lang="scss" scoped>
#main-four{
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  padding-bottom: 72px;
  .three-title{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 64px;
    gap: 12px;
    .title{
      font-family: 'PingFang SC';
      font-weight: 600;
      font-size: 28px;
      color: #031222;
    }
    .text{
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 14px;
      color: rgba(3, 18, 34, 0.4);
    }
  }
  .main-three-footer{
    width: 100%;
    display: flex;
    gap: 20px;
    position: relative;
    .main-three-item{
      width: 32%;
      display: flex;
      flex-direction: column;
      background: #FFFFFF;
      box-shadow: 0px 12px 16px rgba(5, 88, 165, 0.1);
      border-radius: 4px;
      .footer-text{
        display: flex;
        padding: 24px;
        gap: 24px;
        .left{
          display: flex;
          flex-direction: column;
          .left-title{
            font-family: 'FF DIN Pro';
            font-weight: 700;
            font-size: 28px;
            color: #031222;
          }
          .left-text{
            font-family: 'FF DIN Pro';
            font-weight: 700;
            font-size: 14px;
            color: rgba(3, 18, 34, 0.7);
            padding-bottom: 14px;
          }
          .left-line{
            width: 40px;
            height: 1px;
            background: rgba(3, 18, 34, 0.2);
          }
        }
        .right{
          display: flex;
          flex-direction: column;
          gap: 8px;
          .right-title{
            font-family: 'PingFang SC';
            font-weight: 500;
            font-size: 16px;
            color: #031222;
          }
          .right-text{
            font-family: 'PingFang SC';
            font-weight: 400;
            font-size: 12px;
            color: rgba(3, 18, 34, 0.7);
          }
        }
      }
    }
  }
  .three-left-pos{
    position: absolute;
    left: -82px;
    top: 150px;
  }
  .three-right-pos{
    position: absolute;
    right: -82px;
    top: 150px;
  }
  .three-left{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: #1187FF;
    box-shadow: 0px 2px 6px rgba(27, 86, 173, 0.5);
    border-radius: 50%;
    cursor: pointer;
    i{
      color:#FFFFFF;
    }
  }
  .three-right{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 6px rgba(27, 86, 173, 0.25);
    border-radius: 50%;
    cursor: pointer;

    i{
      color:rgba(0, 0, 0, 0.2);
    }
  }

}
</style>